import * as angular from "angular";
import {IController} from "angular";
import {BillingOrder} from "../../models/billing-order.model";
import * as _ from "lodash";


export class BillingOrderResourcesListDisplayComponent implements IController {

  billingOrder: BillingOrder;
  maxItems?: number;

  public resourcesNames: string[];


  constructor() {

  }

  $onInit() {

    if (!this.maxItems) {
      this.maxItems = 1;
    }

    this._initItems();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.billingOrder && !changes.billingOrder.isFirstChange()) {
      this._initItems();
    }
  }

  private _initItems() {
    this.resourcesNames = _.chain(this.billingOrder.billingInfoLines)
      .flatMap('billingInfoSteps')
      .map('routeReference.resourceName')
      .compact()
      .value();
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingOrderResourcesListDisplay', {
    bindings: {
      billingOrder: '<',
      maxItems: '<?'
    },
    template: require('./billing-order-resources-list-display.html').default,
    controller: BillingOrderResourcesListDisplayComponent
  });
